/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateInventoryRecordDto = {
  /**
   * Destination location ID
   */
  destinationLocationId: number;
  /**
   * User ID who registered the record
   */
  registeredById: string;
  /**
   * Record status
   */
  status: CreateInventoryRecordDto.status;
};
export namespace CreateInventoryRecordDto {
  /**
   * Record status
   */
  export enum status {
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
  }
}
